import { lazy } from 'react';
import { Route } from 'react-router-dom';
import DashboardLayout from '../dashboard/_components/dashboard-layout';

const UsagePage = lazy(() => import('../dashboard/usage/page'));
const QuickstartPage = lazy(() => import('../dashboard/quickstart/page'));
const PlaygroundPage = lazy(() => import('../dashboard/playground/page'));
const ModelsPage = lazy(() => import('../dashboard/models/page'));
const ApiKeysPage = lazy(() => import('../dashboard/api-keys/page'));
const LogsPage = lazy(() => import('../dashboard/logs/page'));
const BillingPage = lazy(() => import('../dashboard/billing/page'));
const SettingsPage = lazy(() => import('../dashboard/settings/page'));

export const DashboardRoutes = (
  <>
    <Route
      path="/dashboard/usage"
      element={
        <DashboardLayout>
          <UsagePage />
        </DashboardLayout>
      }
    />
    <Route
      path="/dashboard/quickstart"
      element={
        <DashboardLayout>
          <QuickstartPage />
        </DashboardLayout>
      }
    />
    <Route
      path="/dashboard/playground"
      element={
        <DashboardLayout>
          <PlaygroundPage />
        </DashboardLayout>
      }
    />
    <Route
      path="/dashboard/models"
      element={
        <DashboardLayout>
          <ModelsPage />
        </DashboardLayout>
      }
    />
    <Route
      path="/dashboard/api-keys"
      element={
        <DashboardLayout>
          <ApiKeysPage />
        </DashboardLayout>
      }
    />
    <Route
      path="/dashboard/logs"
      element={
        <DashboardLayout>
          <LogsPage />
        </DashboardLayout>
      }
    />
    <Route
      path="/dashboard/billing"
      element={
        <DashboardLayout>
          <BillingPage />
        </DashboardLayout>
      }
    />
    <Route
      path="/dashboard/settings"
      element={
        <DashboardLayout>
          <SettingsPage />
        </DashboardLayout>
      }
    />
  </>
);
